"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TimeSeriesDataStub_1 = __importDefault(require("./TimeSeriesDataStub"));
const VisitorData_1 = __importDefault(require("../entity/VisitorData"));
const getValue_1 = __importDefault(require("../utility/getValue"));
class VisitorDataStub extends VisitorData_1.default {
    constructor({ 
    // hourly = [
    //   new TimeSeriesDataStub({
    //     label: '2019-01',
    //     values: getValues({
    //       start: '2019-01-01T00:00:00',
    //       end: '2019-02-01T00:00:00',
    //       type: 'hours',
    //     }),
    //   }),
    //   new TimeSeriesDataStub({
    //     label: '2019-02',
    //     values: getValues({
    //       start: '2019-02-01T00:00:00',
    //       end: '2019-03-01T00:00:00',
    //       type: 'hours',
    //     }),
    //   }),
    // ],
    daily = [
        new TimeSeriesDataStub_1.default({
            label: '2019-01',
            values: (0, getValue_1.default)({
                start: '2019-01-01T00:00:00',
                end: '2019-02-01T00:00:00',
                type: 'days',
            }),
        }),
        new TimeSeriesDataStub_1.default({
            label: '2019-02',
            values: (0, getValue_1.default)({
                start: '2019-02-01T00:00:00',
                end: '2019-03-01T00:00:00',
                type: 'days',
            }),
        }),
    ], weekly = [
        new TimeSeriesDataStub_1.default({
            label: '2019-01',
            values: (0, getValue_1.default)({
                start: '2019-01-01T00:00:00',
                end: '2019-01-08T00:00:00',
                type: 'days',
            }),
        }),
        new TimeSeriesDataStub_1.default({
            label: '2019-02',
            values: (0, getValue_1.default)({
                start: '2019-01-09T00:00:00',
                end: '2019-01-16T00:00:00',
                type: 'days',
            }),
        }),
    ], monthly = [
        new TimeSeriesDataStub_1.default({
            label: '2019-01',
            values: (0, getValue_1.default)({
                start: '2019-01-01T00:00:00',
                end: '2019-02-01T00:00:00',
                type: 'months',
            }),
        }),
        new TimeSeriesDataStub_1.default({
            label: '2019-02',
            values: (0, getValue_1.default)({
                start: '2019-02-01T00:00:00',
                end: '2019-03-01T00:00:00',
                type: 'months',
            }),
        }),
    ], } = {}) {
        super({ daily, weekly, monthly });
    }
}
exports.default = VisitorDataStub;
